export const environment = {
    production: false,
    autoReadOTP: false,
    theme: "light", // light // dark
    api_version: "1.0",
    baseUrl: "https://dev-app-api.klinq.co.in/app",
    firebaseConfig: {
        apiKey: "AIzaSyAEU1sFT5mlY1CCne73RlBtbRUD2VQpYAw",
        authDomain: "klinq-dev.firebaseapp.com",
        projectId: "klinq-dev",
        storageBucket: "klinq-dev.firebasestorage.app",
        messagingSenderId: "677277556889",
        appId: "1:677277556889:web:9346c54b770443711e5808",
    },
    mqttConfig: {
        protocol: "wss",
        hostname: "dev-mqtt.klinq.co.in",
        port: 443,
        path: "/mqtt",
        clientId: "customer_",
    },
    mqttTopic: {
        common_topic: "customer-client-events",
        admin_topic: "customer_",
    },
    flyyConfig: {
        baseURL: "https://stage-partner-api.theflyy.com/v1/",
        packageName: "com.shivdurga",
        partnerId: "bcc3cbffdd5487b503e8",
        apiKey: "EaE9fz1OzjM90ZhZHtWkgo6XqlEydfTMRIiOPvt7",
        environment: "development",
        attachMode: "popup",
        wallet: 6844,
        walletExpireDays: 90,
    },
    GOOGLE_CAPTCHA_SITE_KEY: "6Le2z6QsAAAAAOQc3vS4rWMYl47mRN9Hv_c1g5SK",
    ERROR_REPORTING: "https://error-reporting-api.klinq.co.in/api/error/create",
    netcoreConfig: {
        apiKey: "ADGMOT35CHFLVDHBJNIG50K96ACCMRPFVN41ASIC4C8N4PGO15GG",
        siteId: "97e530f238afc685327d51e82ddd4330",
    },
    APP_STORE: "https://www.apple.com/in/app-store/",
    PLAY_STORE: "https://play.google.com/store/apps/details?id=com.myklinq",
    ONELINK: "https://myklinq.onelink.me/zF8n/juuyzm2q",
    newRelic: {
        licenseKey: "DF08A01BEE112E960FCD0F0CEAFAF1BD5F834D025BBB5D676884083798B168EF",
        applicationID: "7874961",
        file: "webapp-dev.js",
    },
};
